<template>
  <b-modal :active.sync="show" has-modal-card :can-cancel="['escape', 'outside']">
    <div class="modal-card" style="max-width: 1000px;">
      <header class="modal-card-head has-background-primary">
        <p class="modal-card-title has-text-white"><i class="fas fa-newspaper-o"></i>&nbsp;Berita Kampus</p>
      </header>
      <section class="modal-card-body">
        <div v-if="loading_get_all">
          <spinner-loading></spinner-loading>
        </div>
        <div v-else-if="!loading_get_all && !isEmpty(news)" v-for="(n, key) in news" :key="key">
          <p class="title has-text-centered">{{ n.title }}</p>
          <p class="subtitle has-text-centered is-6 has-text-grey tooltip" :data-tooltip="n.createdAt"><i class="fas fa-calendar"></i>&nbsp;&nbsp;{{ date_humanize(n.createdAt) }}</p>
          <hr>
          <div class="content" v-html="n.description"></div>
        </div>

        <div v-else-if="!loading_get_all && isEmpty(news)">
          <p class="has-text-centered has-text-grey">Tidak ada berita.</p>
        </div>
      </section>

      <footer class="modal-card-foot" v-if="dataProvider.page.total >= 1" style="padding: 0;">
        <div class="columns is-vcentered" style="width: 100%; margin: 0;">
          <div class="column">
            <div class="columns is-mobile is-vcentered">
              <div class="column" v-if="dataProvider.page.current > dataProvider.page.previous && dataProvider.page.previous > 0">
                <button class="button is-fullwidth" @click.prevent="() => { dataProvider.page['current'] = dataProvider.page['current'] - 1; getUniversityNewsPopup() }">
                  <span class="icon"><i class="fas fa-angle-double-left"></i></span>
                  <span>Baru</span>
                </button>
              </div>
              <div class="column">
                <button class="button is-fullwidth" v-if="dataProvider.page.current < dataProvider.page.next && dataProvider.page.next > 0" @click.prevent="() => { dataProvider.page['current'] = dataProvider.page['current'] + 1; getUniversityNewsPopup() }">
                  <span>Lama</span>
                  <span class="icon"><i class="fas fa-angle-double-right"></i></span>
                </button>
              </div>
            </div>
          </div>
          <div class="column is-narrow">
            <div class="has-text-centered has-text-grey">
              <small>
                <b-checkbox v-model="dont_show_again">
                  Jangan tampilkan lagi
                </b-checkbox>
              </small>
            </div>
          </div>
          <div class="column has-text-right">
            <button type="button" @click.prevent="show = false" class="button is-fullwidth is-hidden-tablet"><span>Tutup</span></button>
            <button type="button" @click.prevent="show = false" class="button is-hidden-mobile"><span>Tutup</span></button>
          </div>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { UNIVERSITY_NEWS } from '~/consts'

export default {
  mounted() {
    const dont_show_un = this.$cookies.get(trans('dont_show_again_university_news'));
    if (!this.isEmpty(this.account) && this.account.type != 'ADMIN' && (this.isEmpty(dont_show_un) || (!this.isEmpty(dont_show_un) && dont_show_un <= 0))) {
      this.getUniversityNewsPopup();
    }
  },

  computed: {
    ...mapState({
      university_news: state => state.university_news,
      university_news_id: state => state.university_news_id,
      account: state => state.auth.active_pt
    }),
    show: {
      get() {
        return this.university_news
      },
      set(val) {
        this.$store.commit('setState', { key: 'university_news', value: val });
      }
    }
  },

  watch: {
    university_news_id(val) {
      if (!this.isEmpty(val)) {
        this.getSingle();
      }
    },
    university_news(val) {
      if (val) {
        if (this.isEmpty(this.university_news_id)) {
          this.dataProvider.page['current'] = 1

          const dont_show_un = this.$cookies.get(trans('dont_show_again_university_news'));
          if (!this.isEmpty(dont_show_un) && dont_show_un > 0) {
            this.dont_show_again = true
          }

          Vue.nextTick(() => {
            this.getUniversityNewsPopup();
          })
        }
      } else {
        this.$store.commit('setState', { key: 'university_news_id', value: null });

        if (this.isEmpty(this.university_news_id)) {
          if (this.dont_show_again) {
            this.$cookies.set(trans('dont_show_again_university_news'), 1, {
              expires: moment().add(1, 'day').toDate(),
              path: '/'
            });
          } else {
            this.$cookies.remove(trans('dont_show_again_university_news'), {
              path: '/'
            });
          }
        }
      }
    },
  },

  data() {
    return {
      loading_get_all: false,
      dont_show_again: false,
      news: [],
      dataProvider: {
        page: {
          current: 1,
          limit: 1
        }
      }
    }
  },

  methods: {
    getUniversityNewsPopup() {
      if (!this.isEmpty(this.university_news_id)) {
        this.getSingle()
      } else {
        this.getPaginatePublished();
      }
    },
    getSingle() {
      const vm = this;

      vm.loading_get_all = true;

      this.$axios.post(UNIVERSITY_NEWS.GET_SINGLE(this.university_news_id))
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.news = [data.data];
            this.dataProvider.page['current'] = 1
            this.dataProvider.page['total'] = 1

            if (!vm.isEmpty(vm.news)) {
              vm.show = true;
            }
          }

          vm.loading_get_all = false;
        }).catch(() => {
          vm.loading_get_all = false;
        })
    },
    getPaginatePublished() {
      const vm = this;

      vm.loading_get_all = true;

      this.$axios.post(UNIVERSITY_NEWS.GET_PUBLISHED_POPUP, {
        dataProvider: JSON.stringify(vm.dataProvider)
      }).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          vm.news = data.data.data;
          vm.dataProvider = data.data.dataProvider

          if (!vm.isEmpty(vm.news)) {
            vm.show = true;
          }
        }

        vm.loading_get_all = false;
      }).catch(() => {
        vm.loading_get_all = false;
      })
    }
  }
}
</script>